import type { FaireProductEntity } from "../../entity_types/product";

export const p_aggnqmrus4: FaireProductEntity = {
  token: "p_aggnqmrus4",
  type: "product",
  name: "Boho Summer Chic Flower Crochet Hollow Knit Top",
  brandToken: "b_m4nc6munyv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f18b5a647a357b4c9f8b319ffea9224befffa582cb0bf8a454f6db21e31dbadf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f614334bdb0880cb18fa377e448e2391b7739204c4dcff80cd011fbda015898.jpeg",
    "https://cdn.faire.com/fastly/e37f07d12fb5d4d4d1e9cf6c542df26eea74c6725109e98ff68c484d0f95a906.jpeg",
    "https://cdn.faire.com/fastly/180fa8a8f19bc6d9379c03fbfc967ba3061a15587a64ee4580e6414bed22fabd.jpeg",
    "https://cdn.faire.com/fastly/215d120cfd2a39546f50d53fb225036cffb8ca4a79bb075954d025ad1771d078.jpeg",
    "https://cdn.faire.com/fastly/efe9dc5a5964fa667ddebb8973a7291cb56ca71fa12da582af0776f63c73b499.jpeg",
    "https://cdn.faire.com/fastly/0e32bb5cb5a8ed55f06e766dd99c7f846531f23a996fb8ce39e67b37e936dd6a.jpeg",
    "https://cdn.faire.com/fastly/c94adae07cf33935587b1de4de6503373abfb14f6a8a543a94c9b654e964fac0.jpeg",
    "https://cdn.faire.com/fastly/21559743cb29e6aed0d59d29e490373c395989c31e3546f3f2aee04fe5acd467.jpeg",
    "https://cdn.faire.com/fastly/a561e67bcee20a3bbea12cdbabb4fc58346928eb2552591869fc3c5be1bb0ee0.jpeg",
  ],
  priceDollars: 24.61,
  description:
    "BOHO SUMMER CHIC FLOWER CROCHET HOLLOW KNIT TOP_RCJW07863\nPrint placement will vary for each individual garment.\n\nSize Chart(Inch)\t\t\t\n\t  Chest\tLength\tSleeve\nS\t 47.24 \t     22.44 \t 33.07 \nM\t 48.82 \t 22.83  \t 33.86 \nL\t 51.18   \t 23.43 \t 34.65 \nXL 53.54 \t 24.02 \t 35.43 \n\nWomen shackets,crochet cardigan,cable knit sweater,ruffle dress,blouse,puff sleeve western vintage Christmas top,denim skirts,fall top,fall dress,blazer，Knit cardigan,Midi dress,Laple Shirts,Tank Top,Knit Top,High waist pants,Button down Jacket,Skirt,Ruffle Valentine's Day blouse,Sweatshirt,hoodie,midi dress,knit sweater,2 piece set,denim jacket,plaid shirt,zip up jacket,wide leg pant,fur coat，tweed jacket,2026 Women Apparel",
  tags: [],
  msrpDollars: 49.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:09.253Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
